import Api from "../userApiServices/axiosInstance";


const searchContacts = async (req) => {
  const url = '/grpc/contacts.ContactsService/Find';
  const response = await Api.post(url, req);
  return response.data;
};

const addContact = async (req) => {
  const url = '/grpc/contacts.ContactsService/Add';
  const response = await Api.post(url, req);
  return response.data;
};

const updateContact = async (req) => {
  const url = '/grpc/contacts.ContactsService/Update';
  const response = await Api.post(url, req);
  return response.data;
};

const inviteContacts = async (req) => {
  const url = '/grpc/contacts.ContactsService/Invite';
  const response = await Api.post(url, req);
  return response.data;
};

const removeContact = async (req) => {
  const url = '/grpc/contacts.ContactsService/Remove';
  const response = await Api.post(url, req);
  return response.data;
};

const acceptContact = async (req) => {
  const url = '/grpc/contacts.ContactsService/Accept';
  const response = await Api.post(url, req);
  return response.data;
};

const ignoreContact = async (req) => {
  const url = '/grpc/contacts.ContactsService/Ignore';
  const response = await Api.post(url, req);
  return response.data;
};

const ContactsServiceClient = {
  searchContacts,
  addContact,
  updateContact,
  inviteContacts,
  removeContact,
  acceptContact,
  ignoreContact,
};

export default ContactsServiceClient;